<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
             <v-flex xs8>

               <v-alert
                  value="message" v-if="message"
                  type="success"
                  outline
                > <span> {{ message }} </span>
                </v-alert>

                 <v-alert
                  value="error" v-if="error"
                  type="warning"
                  outline
                > <span> {{ error }} </span>
                </v-alert>

               <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ request }} Role Creation Request</span>
                  </v-card-title>
        
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                       <v-form ref="form" v-model="valid" lazy-validation>
                          <v-text-field 
                           v-model="editedItem.name" 
                           label="Name"
                           required
                           readonly
                           >
                           </v-text-field>

                            <v-text-field 
                             v-model="editedItem.description" 
                             label="Description"
                             required
                           >
                           </v-text-field>

                           <h4>Permissions </h4>
                            <v-flex>
                               <v-chip color="green" :key="selected" v-for="selected in editedItem.selectedPermissions">{{ selected }}</v-chip>
                            </v-flex>

                        </v-form>
                      </v-layout>
                    </v-container>
                  </v-card-text>
        
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" @click.native="close">Cancel</v-btn>
                    <v-btn color="primary" @click.native="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>

            <v-data-table
              :headers="headers"
              :items="roles"
              :pagination.sync="pagination"
              :total-items="totalRoles"
              :loading="loading"
              class="elevation-1"
            >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.makerUsername }}</td>
              <td>{{ props.item.requestType }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td class="justify-center layout px-0">
                <v-btn color="secondary" @click="approveItem(props.item)">
                  Approve
                </v-btn>
                <v-btn color="error" @click="declineItem(props.item)">
                  Decline
                </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../config'
import store from '../../store'

export default {
  name: 'viewadmin',
  data: function() {
    return {
      headers: [
        {
          text: 'Id',
          value: 'id'
        },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Maker', value: 'makerUsername' },
        { text: 'Request Type', value: 'requestType' },
        { text: 'Created At', value: 'createdAt' }
      ],
      roles: [],
      role: {
        'name': '',
        'description': '',
        'requestType': '',
        'selectedPermissions': []
      },
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalRoles: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        id: '',
        name: '',
        description: '',
        requestType: '',
        selectedPermissions: []
      },
      editedItem: {
        id: '',
        name: '',
        description: '',
        requestType: '',
        selectedPermissions: []
      },
      valid: true,
      rowsPerPageItems: [4, 8, 12],
      paginationPermissions: {
        rowsPerPage: 4
      },
      permissions: [],
      permissionsAssignedToRole: [],
      request: ''
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.permissions = data.items
        // this.totalPermissions = data.total
      })
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination

        let items = this.getRolesToBeApproved()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    approveItem (item) {
      this.editedIndex = this.roles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Approve'
      this.editedItem.approvalStatus = 'approved'
    },
    declineItem (item) {
      this.editedIndex = this.roles.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Decline'
      this.editedItem.approvalStatus = 'declined'
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.approvalStatus === 'approved') {
          this.sendRequest('approve')
        } else if (this.editedItem.approvalStatus === 'declined') {
          this.sendRequest('decline')
        }
        this.close()
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    getRolesToBeApproved () {
      var url = config.serverURI + '/admin/role/getUnapprovedRoles'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.roles = response.data
            this.totalRoles = this.roles.total
            console.log(response.data)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response
            console.log(data.message)
            if (data.message === 'Unauthorized' || data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.roles
    },
    getRolesPermissions (role) {
      var url = config.serverURI + '/admin/role/' + role.id + '/permissions'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            const mapFunction = p => p.action
            this.permissionsAssignedToRole = response.data.map(mapFunction)
            console.log(response.data)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.roles
    },
    sendRequest(request) {
      var url = config.serverURI + '/admin/role/' + request
      var token = store.state.token
      this.message = ''
      axios.post(url, this.editedItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            if (response.data.error !== false) {
              this.error = response.data.message
              console.log('Error is ' + this.error)
              return
            }
            this.roles = this.getRolesToBeApproved()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error)
            var data = error.response
            if (data.message === 'Unauthorized' || data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// approverole.vue?17aa4363